module.exports = __webpack_public_path__ + "static/media/Peyronie.17004bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Peyronie.png
// module id = 662
// module chunks = 0